import React from "react";
import Popover from "@mui/material/Popover";
//OUR COMPONENTS
import {
  TicketingAndroid,
  AndroidStore,
  AppStore,
  TicketingIos,
} from "../Assets/Icon";

const QrCodes = () => {
  //FOR POPOVER
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl1, setAnchorEl1] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handlePopoverOpen1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };

  const handlePopoverClose1 = () => {
    setAnchorEl1(null);
  };
  const open1 = Boolean(anchorEl1);
  const open = Boolean(anchorEl);

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: 12,
          alignItems: "center",
          padding: 16,
        }}
      >
        <div
          style={{
            position: "relative",
            cursor: "pointer",
            transition: "transform 0.2s ease",
          }}
          onClick={() =>
            window.open(
              "https://play.google.com/store/apps/details?id=com.treeoneticketing"
            )
          }
          onMouseEnter={handlePopoverOpen1}
          onMouseLeave={handlePopoverClose1}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "12px 20px",
              backgroundColor: "white",
              border: "1px solid #e0e0e0",
              borderRadius: 12,
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            }}
          >
            <TicketingAndroid
              style={{
                width: 40,
                height: 40,
              }}
            />
            <AndroidStore
              style={{
                width: 100,
                height: 32,
              }}
            />
          </div>
          <Popover
            id="mouse-over-popover"
            sx={{ pointerEvents: "none" }}
            open={open1}
            anchorEl={anchorEl1}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            onClose={handlePopoverClose1}
            disableRestoreFocus
            slotProps={{
              paper: {
                style: {
                  marginTop: 8,
                  borderRadius: 12,
                  boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                },
              },
            }}
          >
            <div style={{ padding: 16 }}>
              <TicketingAndroid
                style={{
                  width: 150,
                  height: 150,
                }}
              />
            </div>
          </Popover>
        </div>
        <div
          style={{
            position: "relative",
            cursor: "pointer",
            transition: "transform 0.2s ease",
          }}
          onClick={() =>
            window.open(
              "https://apps.apple.com/us/app/treeone-ticketing-team/id6478576011"
            )
          }
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "12px 20px",
              backgroundColor: "white",
              border: "1px solid #e0e0e0",
              borderRadius: 12,
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            }}
          >
            <TicketingIos
              style={{
                width: 40,
                height: 40,
              }}
            />
            <AppStore
              style={{
                width: 100,
                height: 32,
              }}
            />
          </div>
          <Popover
            id="mouse-over-popover"
            sx={{ pointerEvents: "none" }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
            slotProps={{
              paper: {
                style: {
                  marginTop: 8,
                  borderRadius: 12,
                  boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                },
              },
            }}
          >
            <div style={{ padding: 16 }}>
              <TicketingIos
                style={{
                  width: 150,
                  height: 150,
                }}
              />
            </div>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default QrCodes;
